import { isValidLetters } from '../../../utils/validators';
import { ELetterErrorMessages } from '../constants';

export const letterValidator = (required: boolean) => (value: unknown) => {
  if (!!value && isValidLetters(value) && (value as string).length > 100) {
    return ELetterErrorMessages.Max;
  }

  return (!value && !required) || (!!value && isValidLetters(value)) ? null : ELetterErrorMessages.Required;
};
